<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Ponto dos Colaboradores
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="pontos-page__content">
            <v-row dense align="center">
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="colaboradorId"
                  :items="colaboradores"
                  item-text="name"
                  item-value="id"
                  label="Colaborador(a)"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>

            <e-horario-tabs v-model="tab" class="pontos-page__tabs" />

            <section v-if="tab === 0" class="pontos-page__section">
              <e-horario-dia-filtro
                v-model="dataSelecionada"
                class="pontos-page__filter"
                :disabled="!colaboradorId"
                @buscar="buscarDia"
              />
              <e-horario-lista-agrupada
                :registros="registrosDia"
                modo-admin
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="abrirExcluirBatida"
              />
            </section>

            <section v-if="tab === 1" class="pontos-page__section">
              <v-btn
                color="primary"
                class="pontos-page__action"
                :disabled="!colaboradorId"
                @click="buscarUltimos10Dias"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <e-horario-lista-agrupada
                :registros="registrosUltimos10Dias"
                modo-admin
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="abrirExcluirBatida"
              />
            </section>

            <section v-if="tab === 2" class="pontos-page__section">
              <e-horario-periodo-filtro
                class="pontos-page__filter"
                :disabled="!colaboradorId"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <e-horario-lista-agrupada
                :registros="registrosPeriodo"
                modo-admin
                @nova-batida="abrirCriarBatida"
                @editar-batida="abrirEditarBatida"
                @excluir-batida="abrirExcluirBatida"
              />
            </section>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogCriar" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left>mdi-plus-circle-outline</v-icon>
          Novo Registro Manual
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="formBatida.colaborador_id"
                :items="colaboradores"
                item-text="name"
                item-value="id"
                label="Colaborador(a) *"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formBatida.data" label="Data *" type="date" outlined dense />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="formBatida.hora"
                label="Horário *"
                type="time"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="formBatida.tipo_evento"
                label="Tipo (opcional)"
                placeholder="ex: entrada, saída"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="formBatida.justificativa"
                label="Justificativa *"
                placeholder="Descreva o motivo do registro manual (mín. 10 caracteres)"
                outlined
                dense
                rows="3"
                counter="500"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCriar = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="salvandoBatida"
            :disabled="
              salvandoBatida ||
              !formBatida.colaborador_id ||
              !formBatida.data ||
              !formBatida.hora ||
              !formBatida.justificativa ||
              formBatida.justificativa.length < 10 ||
              formBatida.justificativa.length > 500
            "
            @click="confirmarCriarBatida"
          >
            Registrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditar" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left>mdi-pencil-outline</v-icon>
          Editar Batida
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formBatida.data" label="Data" type="date" outlined dense />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="formBatida.hora" label="Horário" type="time" outlined dense />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="formBatida.tipo_evento"
                label="Tipo (opcional)"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="formBatida.justificativa"
                label="Justificativa *"
                placeholder="Descreva o motivo da alteração (mín. 10 caracteres)"
                outlined
                dense
                rows="3"
                counter="500"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogEditar = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="salvandoBatida"
            :disabled="
              salvandoBatida ||
              formBatida.justificativa.length < 10 ||
              formBatida.justificativa.length > 500
            "
            @click="confirmarEditarBatida"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExcluir" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left color="error">mdi-delete-outline</v-icon>
          Excluir Batida
        </v-card-title>
        <v-card-text>
          <v-alert dense outlined type="warning" class="mb-4">
            Esta ação excluirá a batida de
            <strong>{{
              batidaSelecionada && (batidaSelecionada.hora_formatada || batidaSelecionada.hora)
            }}</strong>
            do dia
            <strong>{{
              batidaSelecionada && (batidaSelecionada.data_formatada || batidaSelecionada.data)
            }}</strong
            >. A jornada será recalculada automaticamente.
          </v-alert>
          <v-textarea
            v-model="justificativaExclusao"
            label="Justificativa *"
            placeholder="Descreva o motivo da exclusão (mín. 10 caracteres)"
            outlined
            dense
            rows="3"
            counter="500"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn
            color="error"
            :loading="excluindoBatida"
            :disabled="
              excluindoBatida ||
              justificativaExclusao.length < 10 ||
              justificativaExclusao.length > 500
            "
            @click="confirmarExcluirBatida"
          >
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHistorico" max-width="700" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon left>mdi-history</v-icon>
          Histórico de Alterações de Batidas
        </v-card-title>
        <v-card-text>
          <v-progress-linear
            v-if="carregandoHistorico"
            indeterminate
            color="primary"
            class="mb-4"
          />
          <v-alert v-else-if="!historico.length" dense outlined type="info">
            Nenhuma alteração registrada para este colaborador.
          </v-alert>
          <v-simple-table v-else dense>
            <thead>
              <tr>
                <th>Ação</th>
                <th>Data/Hora</th>
                <th>Antes</th>
                <th>Depois</th>
                <th>Justificativa</th>
                <th>Responsável</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in historico" :key="idx">
                <td>
                  <v-chip x-small :color="corAcao(item.acao)" dark>{{ item.acao }}</v-chip>
                </td>
                <td class="body-2">{{ formatarDataHora(item.created_at) }}</td>
                <td class="body-2">
                  <span v-if="item.dados_anteriores">
                    {{ item.dados_anteriores.data }} {{ item.dados_anteriores.hora }}
                  </span>
                  <span v-else>—</span>
                </td>
                <td class="body-2">
                  <span v-if="item.dados_novos">
                    {{ item.dados_novos.data }} {{ item.dados_novos.hora }}
                  </span>
                  <span v-else>—</span>
                </td>
                <td class="body-2" style="max-width: 180px; white-space: normal">
                  {{ item.justificativa }}
                </td>
                <td class="body-2">{{ item.responsavel && item.responsavel.name }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogHistorico = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto — Colaborador"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
export default {
  name: "ColaboradoresPontosAdminPage",
  components: {},
  data() {
    return {
      tab: 0,
      colaboradorId: null,
      colaboradores: [],
      dataSelecionada: new Date().toISOString().slice(0, 10),
      registrosDia: null,
      registrosUltimos10Dias: null,
      registrosPeriodo: null,
      dialogPdf: false,
      pdf: null,
      dialogCriar: false,
      dialogEditar: false,
      salvandoBatida: false,
      batidaSelecionada: null,
      formBatida: { colaborador_id: null, data: "", hora: "", tipo_evento: "", justificativa: "" },
      dialogExcluir: false,
      excluindoBatida: false,
      justificativaExclusao: "",
      dialogHistorico: false,
      carregandoHistorico: false,
      historico: [],
      ultimoFiltroPeriodo: null,
    };
  },
  watch: {
    colaboradorId() {
      this.registrosDia = null;
      this.registrosUltimos10Dias = null;
      this.registrosPeriodo = null;
      if (this.colaboradorId) {
        if (this.tab === 0) this.buscarDia();
        else if (this.tab === 1) this.buscarUltimos10Dias();
        else if (this.tab === 2 && this.ultimoFiltroPeriodo)
          this.buscarPeriodo(this.ultimoFiltroPeriodo);
      }
    },
    tab(novoTab) {
      if (!this.colaboradorId) return;
      if (novoTab === 0 && this.registrosDia === null) this.buscarDia();
      else if (novoTab === 1 && this.registrosUltimos10Dias === null) this.buscarUltimos10Dias();
      else if (novoTab === 2 && this.registrosPeriodo === null && this.ultimoFiltroPeriodo)
        this.buscarPeriodo(this.ultimoFiltroPeriodo);
    },
  },
  mounted() {
    this.carregarColaboradores();
  },
  methods: {
    async carregarColaboradores() {
      try {
        this.colaboradores = await this.$services.colaboradorPontosService.listarColaboradores();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async buscarDia() {
      if (!this.colaboradorId) return;
      try {
        this.$loaderService.open("Carregando pontos");
        this.registrosDia = await this.$services.colaboradorPontosService.adminPontosDia({
          colaborador_id: this.colaboradorId,
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async buscarUltimos10Dias() {
      if (!this.colaboradorId) return;
      try {
        this.$loaderService.open("Carregando pontos");
        this.registrosUltimos10Dias =
          await this.$services.colaboradorPontosService.adminPontosUltimos10Dias({
            colaborador_id: this.colaboradorId,
          });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async buscarPeriodo(form) {
      if (!this.colaboradorId || !form.data_inicio || !form.data_fim) return;
      this.ultimoFiltroPeriodo = form;
      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.colaboradorPontosService.adminPontosPeriodo({
          colaborador_id: this.colaboradorId,
          ...form,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async gerarPdfPeriodo(form) {
      if (!this.colaboradorId || !form.data_inicio || !form.data_fim) return;
      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.colaboradorPontosService.adminPontosPeriodoPdf({
          colaborador_id: this.colaboradorId,
          ...form,
        });
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },

    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },

    abrirCriarBatida(data) {
      const dataFormatada =
        data && data !== "dia"
          ? data
          : this.dataSelecionada || new Date().toISOString().slice(0, 10);
      this.formBatida = {
        colaborador_id: this.colaboradorId || null,
        data: dataFormatada,
        hora: "",
        tipo_evento: "",
        justificativa: "",
      };
      this.dialogCriar = true;
    },

    async confirmarCriarBatida() {
      const targetColaboradorId = this.formBatida.colaborador_id || this.colaboradorId;
      if (!targetColaboradorId) {
        this.$toast.danger("Selecione o colaborador.");
        return;
      }
      if (!this.formBatida.data || !this.formBatida.hora) {
        this.$toast.danger("Preencha a data e o horário.");
        return;
      }
      if (!this.formBatida.justificativa || this.formBatida.justificativa.length < 10) {
        this.$toast.danger("A justificativa deve ter ao menos 10 caracteres.");
        return;
      }
      try {
        this.salvandoBatida = true;
        await this.$services.colaboradorPontosService.criarBatida({
          colaborador_user_id: targetColaboradorId,
          data: this.formBatida.data,
          hora: this.formBatida.hora,
          tipo_evento: this.formBatida.tipo_evento || null,
          justificativa: this.formBatida.justificativa,
        });
        this.$toast.success("Batida registrada com sucesso.");
        this.dialogCriar = false;

        if (this.colaboradorId !== targetColaboradorId) {
          this.colaboradorId = targetColaboradorId;
        } else {
          this.recarregarConsultaAtiva();
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvandoBatida = false;
      }
    },

    abrirEditarBatida(item) {
      this.batidaSelecionada = item;
      this.formBatida = {
        data: item.data,
        hora: (item.hora || "").slice(0, 5),
        tipo_evento: item.tipo_evento || "",
        justificativa: "",
      };
      this.dialogEditar = true;
    },

    async confirmarEditarBatida() {
      if (!this.formBatida.data || !this.formBatida.hora) {
        this.$toast.danger("Preencha a data e o horário.");
        return;
      }
      if (!this.formBatida.justificativa || this.formBatida.justificativa.length < 10) {
        this.$toast.danger("A justificativa deve ter ao menos 10 caracteres.");
        return;
      }
      try {
        this.salvandoBatida = true;
        await this.$services.colaboradorPontosService.editarBatida(this.batidaSelecionada.id, {
          data: this.formBatida.data,
          hora: this.formBatida.hora,
          tipo_evento: this.formBatida.tipo_evento || null,
          justificativa: this.formBatida.justificativa,
        });
        this.$toast.success("Batida atualizada com sucesso.");
        this.dialogEditar = false;
        this.recarregarConsultaAtiva();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvandoBatida = false;
      }
    },

    abrirExcluirBatida(item) {
      this.batidaSelecionada = item;
      this.justificativaExclusao = "";
      this.dialogExcluir = true;
    },

    async confirmarExcluirBatida() {
      if (!this.justificativaExclusao || this.justificativaExclusao.length < 10) {
        this.$toast.danger("A justificativa deve ter ao menos 10 caracteres.");
        return;
      }
      try {
        this.excluindoBatida = true;
        await this.$services.colaboradorPontosService.excluirBatida(this.batidaSelecionada.id, {
          justificativa: this.justificativaExclusao,
        });
        this.$toast.success("Batida excluída com sucesso.");
        this.dialogExcluir = false;
        this.recarregarConsultaAtiva();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.excluindoBatida = false;
      }
    },

    async abrirHistorico() {
      this.historico = [];
      this.dialogHistorico = true;
      this.carregandoHistorico = true;
      try {
        this.historico = await this.$services.colaboradorPontosService.historicoAjustesBatidas(
          this.colaboradorId
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoHistorico = false;
      }
    },

    recarregarConsultaAtiva() {
      if (this.tab === 0) this.buscarDia();
      else if (this.tab === 1) this.buscarUltimos10Dias();
      else if (this.tab === 2 && this.ultimoFiltroPeriodo)
        this.buscarPeriodo(this.ultimoFiltroPeriodo);
    },

    corAcao(acao) {
      return { criado: "success", editado: "primary", excluido: "error" }[acao] || "grey";
    },

    formatarDataHora(valor) {
      if (!valor) return "—";
      return new Date(valor).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.pontos-page__content {
  padding: 24px;
}
.pontos-page__tabs {
  margin-top: 24px;
}
.pontos-page__section {
  margin-top: 20px;
}
.pontos-page__filter,
.pontos-page__action {
  margin-bottom: 20px;
}
</style>
